import React from 'react'
import T from '../i18n/T'
import { selectIsSuggestInputValueEmpty } from '../../store/suggest/suggest.selectors'
import { useSelector } from 'react-redux'
import SuggestContentList from './SuggestContentList'
import s from './SuggestContent.less'
import { isEmpty } from '../../utils/lang'

const SuggestSearchHistoryContent = ({
  suggestionsSearchHistory,
  idxStartAt,
  selectedId,
  updateSelectedId,
  onClick
}) => {
  const isInputValueEmpty = useSelector(selectIsSuggestInputValueEmpty)
  const hasSearchHistorySuggests = !isEmpty(suggestionsSearchHistory)

  return (
    <>
      {hasSearchHistorySuggests && isInputValueEmpty && (
        <div className={s.SuggestTitle}>
          <span>
            <T id={'suggest.history.last-searches'} />
          </span>
        </div>
      )}

      <SuggestContentList
        suggestions={suggestionsSearchHistory}
        idxStartAt={idxStartAt}
        onClick={onClick}
        selectedId={selectedId}
        updateSelectedId={updateSelectedId}
      />
    </>
  )
}
export default SuggestSearchHistoryContent
